


















import Vue from 'vue';
import Component from 'vue-class-component';

import { generateId } from './util';
import VueJsModal from './VueJsModal.vue';
import Service from '.';

const PREFIX = '_dynamic_modal_';

@Component({
    components: { VueJsModal },
})
export default class ModalsContainer extends Vue {
    private modals = [];

    private created() {
        if (this.$isServer) return;
        (this.$root as any)._dynamicContainer = this;
    }

    private add(component, componentAttrs = {}, modalAttrs: any = {}, modalListeners) {
        const id = generateId();
        const name = modalAttrs.name || PREFIX + id;

        this.modals.push({
            id,
            modalAttrs: { ...modalAttrs, name },
            modalListeners,
            component,
            componentAttrs,
        });

        this.$nextTick(() => {
            this.show(name);
        });
    }

    private remove(id) {
        for (const i in this.modals) {
            if (this.modals[i].id === id) {
                (this.modals as any).splice(i, 1);
                return;
            }
        }
    }

    private show(name) {
        Service.$modal.show(name);
    }

    private hide(name) {
        Service.$modal.hide(name);
    }
}
